"use strict";

var _toConsumableArray = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/bhautik/Project/macrometa/demo-crypto-trading-5g/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var querystring_1 = require("querystring");

var error_1 = require("./error");

var request_1 = require("./util/request");

var jwtDecode = require("jwt-decode");

var LinkedList = require("linkedlist/lib/linkedlist");

exports.MIME_JSON = /\/(json|javascript)(\W|$)/;
var LEADER_ENDPOINT_HEADER = "x-c8-endpoint";

function isSystemError(err) {
  return Object.getPrototypeOf(err) === Error.prototype && err.hasOwnProperty("code") && err.hasOwnProperty("errno") && err.hasOwnProperty("syscall");
}

var Connection = /*#__PURE__*/function () {
  function Connection() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Connection);

    this._activeTasks = 0;
    this._c8Version = 30000;
    this._fabricName = "_system";
    this._tenantName = "_mm";
    this._queue = new LinkedList();
    this._hosts = [];
    this._urls = [];
    if (typeof config === "string") config = {
      url: config
    };else if (Array.isArray(config)) config = {
      url: config
    };

    if (config.c8Version !== undefined) {
      this._c8Version = config.c8Version;
    }

    if (config.fabricName) {
      this._fabricName = config.fabricName;
    }

    if (config.isAbsolute) {
      this._fabricName = false;
      this._tenantName = false;
    }

    this._agent = config.agent;
    this._agentOptions = request_1.isBrowser ? Object.assign({}, config.agentOptions) : Object.assign({
      maxSockets: 3,
      keepAlive: true,
      keepAliveMsecs: 1000
    }, config.agentOptions);
    this._maxTasks = this._agentOptions.maxSockets || 3;
    if (this._agentOptions.keepAlive) this._maxTasks *= 2;
    this._headers = Object.assign({}, config.headers);

    if (config.token) {
      this._headers = Object.assign({}, this._headers, {
        authorization: "Bearer ".concat(config.token)
      });

      var _jwtDecode = jwtDecode(config.token),
          tenant = _jwtDecode.tenant;

      this._tenantName = tenant;
    }

    if (config.apiKey) {
      this._headers = Object.assign({}, this._headers, {
        authorization: "apikey ".concat(config.apiKey)
      });
      this._tenantName = this.extractTenantName(config.apiKey);
    }

    this._loadBalancingStrategy = config.loadBalancingStrategy || "NONE";
    this._useFailOver = this._loadBalancingStrategy !== "ROUND_ROBIN";

    if (config.maxRetries === false) {
      this._shouldRetry = false;
      this._maxRetries = 0;
    } else {
      this._shouldRetry = true;
      this._maxRetries = config.maxRetries || 0;
    }

    var urls = config.url ? Array.isArray(config.url) ? config.url : [config.url] : ["https://test.macrometa.io"];
    var apiUrls = urls.map(function (url) {
      return "https://api-".concat(url.split("https://")[1]);
    });
    this.addToHostList(apiUrls);

    if (this._loadBalancingStrategy === "ONE_RANDOM") {
      this._activeHost = Math.floor(Math.random() * this._hosts.length);
    } else {
      this._activeHost = 0;
    }
  }

  _createClass(Connection, [{
    key: "_runQueue",
    value: function _runQueue() {
      var _this = this;

      if (!this._queue.length || this._activeTasks >= this._maxTasks) return;

      var task = this._queue.shift();

      var host = this._activeHost;

      if (task.host !== undefined) {
        host = task.host;
      } else if (this._loadBalancingStrategy === "ROUND_ROBIN") {
        this._activeHost = (this._activeHost + 1) % this._hosts.length;
      }

      this._activeTasks += 1;

      this._hosts[host](task.options, function (err, res) {
        _this._activeTasks -= 1;

        if (err) {
          if (_this._hosts.length > 1 && _this._activeHost === host && _this._useFailOver) {
            _this._activeHost = (_this._activeHost + 1) % _this._hosts.length;
          }

          if (!task.host && _this._shouldRetry && task.retries < (_this._maxRetries || _this._hosts.length - 1) && isSystemError(err) && err.syscall === "connect" && err.code === "ECONNREFUSED") {
            task.retries += 1;

            _this._queue.push(task);
          } else {
            task.reject(err);
          }
        } else {
          if (request_1.isBrowser && _this._agent) {
            var response = res;

            if (response.status === 503 && response.headers.get(LEADER_ENDPOINT_HEADER)) {
              var url = response.headers.get(LEADER_ENDPOINT_HEADER);

              var _this$addToHostList = _this.addToHostList(url),
                  _this$addToHostList2 = _slicedToArray(_this$addToHostList, 1),
                  index = _this$addToHostList2[0];

              task.host = index;

              if (_this._activeHost === host) {
                _this._activeHost = index;
              }

              _this._queue.push(task);
            } else {
              response.host = host;
              task.resolve(response);
            }
          } else {
            var _response = res;

            if (_response.statusCode === 503 && _response.headers[LEADER_ENDPOINT_HEADER]) {
              var _url = _response.headers[LEADER_ENDPOINT_HEADER];

              var _this$addToHostList3 = _this.addToHostList(_url),
                  _this$addToHostList4 = _slicedToArray(_this$addToHostList3, 1),
                  _index = _this$addToHostList4[0];

              task.host = _index;

              if (_this._activeHost === host) {
                _this._activeHost = _index;
              }

              _this._queue.push(task);
            } else {
              _response.host = host;
              task.resolve(_response);
            }
          }
        }

        _this._runQueue();
      });
    }
  }, {
    key: "_buildUrl",
    value: function _buildUrl(_ref) {
      var _ref$absolutePath = _ref.absolutePath,
          absolutePath = _ref$absolutePath === void 0 ? false : _ref$absolutePath,
          basePath = _ref.basePath,
          path = _ref.path,
          qs = _ref.qs;
      var pathname = "";
      var search;

      if (!absolutePath) {
        pathname = this._fabricPath;
        if (basePath) pathname += basePath;
      }

      if (path) pathname += path;

      if (qs) {
        if (typeof qs === "string") search = "?".concat(qs);else search = "?".concat(querystring_1.stringify(qs));
      }

      return search ? {
        pathname: pathname,
        search: search
      } : {
        pathname: pathname
      };
    }
  }, {
    key: "_sanitizeEndpointUrl",
    value: function _sanitizeEndpointUrl(url) {
      if (url.startsWith("tcp:")) return url.replace(/^tcp:/, "http:");
      if (url.startsWith("ssl:")) return url.replace(/^ssl:/, "https:");
      return url;
    }
  }, {
    key: "addToHostList",
    value: function addToHostList(urls) {
      var _this2 = this,
          _this$_urls,
          _this$_hosts;

      var cleanUrls = (Array.isArray(urls) ? urls : [urls]).map(function (url) {
        return _this2._sanitizeEndpointUrl(url);
      });
      var newUrls = cleanUrls.filter(function (url) {
        return _this2._urls.indexOf(url) === -1;
      });

      (_this$_urls = this._urls).push.apply(_this$_urls, _toConsumableArray(newUrls));

      (_this$_hosts = this._hosts).push.apply(_this$_hosts, _toConsumableArray(newUrls.map(function (url) {
        return request_1.createRequest(url, _this2._agentOptions, _this2._agent);
      })));

      return cleanUrls.map(function (url) {
        return _this2._urls.indexOf(url);
      });
    }
  }, {
    key: "getFabricName",
    value: function getFabricName() {
      return this._fabricName;
    }
  }, {
    key: "getTenantName",
    value: function getTenantName() {
      return this._tenantName;
    }
  }, {
    key: "getUrls",
    value: function getUrls() {
      return this._urls;
    }
  }, {
    key: "getActiveHost",
    value: function getActiveHost() {
      return this._activeHost;
    }
  }, {
    key: "setFabricName",
    value: function setFabricName(fabricName) {
      if (this._fabricName === false) {
        throw new Error("Can not change fabric from absolute URL");
      }

      this._fabricName = fabricName;
    }
  }, {
    key: "setTenantName",
    value: function setTenantName(tenantName) {
      if (this._tenantName === false) {
        throw new Error("Can not change tenant from absolute URL");
      }

      this._tenantName = tenantName;
    }
  }, {
    key: "setHeader",
    value: function setHeader(key, value) {
      this._headers[key] = value;
    }
  }, {
    key: "close",
    value: function close() {
      var _iterator = _createForOfIteratorHelper(this._hosts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var host = _step.value;
          if (host.close) host.close();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "extractTenantName",
    value: function extractTenantName(apiKey) {
      var apiKeyArr = apiKey.split(".");
      apiKeyArr.splice(-2, 2);
      return apiKeyArr.join(".");
    }
  }, {
    key: "request",
    value: function request(_a, getter) {
      var _this3 = this;

      var host = _a.host,
          _a$method = _a.method,
          method = _a$method === void 0 ? "GET" : _a$method,
          body = _a.body,
          _a$expectBinary = _a.expectBinary,
          expectBinary = _a$expectBinary === void 0 ? false : _a$expectBinary,
          _a$isBinary = _a.isBinary,
          isBinary = _a$isBinary === void 0 ? false : _a$isBinary,
          headers = _a.headers,
          urlInfo = __rest(_a, ["host", "method", "body", "expectBinary", "isBinary", "headers"]);

      return new Promise(function (_resolve, reject) {
        var contentType = "text/plain";

        if (isBinary) {
          contentType = "application/octet-stream";
        } else if (body) {
          if (typeof body === "object") {
            body = JSON.stringify(body);
            contentType = "application/json";
          } else {
            body = String(body);
          }
        }

        var extraHeaders = Object.assign({}, _this3._headers, {
          "content-type": contentType,
          "x-c8-version": String(_this3._c8Version)
        });

        _this3._queue.push({
          retries: 0,
          host: host,
          options: {
            url: _this3._buildUrl(urlInfo),
            headers: Object.assign({}, extraHeaders, headers),
            method: method,
            expectBinary: expectBinary,
            body: body
          },
          reject: reject,
          resolve: function resolve(res) {
            if (request_1.isBrowser && _this3._agent) {
              res.json().then(function (data) {
                if (data.hasOwnProperty("error") && data.hasOwnProperty("code") && data.hasOwnProperty("errorMessage") && data.hasOwnProperty("errorNum")) {
                  reject(new error_1.C8Error({
                    body: data
                  }));
                } else if (res.status && res.status >= 400) {
                  reject(new error_1.HttpError({
                    body: data
                  }));
                } else {
                  _resolve(getter ? getter({
                    body: data
                  }) : {
                    body: data
                  });
                }
              }).catch(function (err) {
                reject(err);
              });
            } else {
              var _contentType = res.headers["content-type"];
              var parsedBody = undefined;

              if (res.body.length && _contentType && _contentType.match(exports.MIME_JSON)) {
                try {
                  parsedBody = res.body;
                  parsedBody = JSON.parse(parsedBody);
                } catch (e) {
                  if (!expectBinary) {
                    if (typeof parsedBody !== "string") {
                      parsedBody = res.body.toString("utf-8");
                    }

                    e.response = res;
                    reject(e);
                    return;
                  }
                }
              } else if (res.body && !expectBinary) {
                parsedBody = res.body.toString("utf-8");
              } else {
                parsedBody = res.body;
              }

              if (parsedBody && parsedBody.hasOwnProperty("error") && parsedBody.hasOwnProperty("code") && parsedBody.hasOwnProperty("errorMessage") && parsedBody.hasOwnProperty("errorNum")) {
                res.body = parsedBody;
                reject(new error_1.C8Error(res));
              } else if (res.statusCode && res.statusCode >= 400) {
                res.body = parsedBody;
                reject(new error_1.HttpError(res));
              } else {
                if (!expectBinary) res.body = parsedBody;

                _resolve(getter ? getter(res) : res);
              }
            }
          }
        });

        _this3._runQueue();
      });
    }
  }, {
    key: "_fabricPath",
    get: function get() {
      return this._fabricName === false ? "" : "/_tenant/".concat(this._tenantName, "/_fabric/").concat(this._fabricName);
    }
  }, {
    key: "c8Major",
    get: function get() {
      return Math.floor(this._c8Version / 10000);
    }
  }]);

  return Connection;
}();

exports.Connection = Connection;